;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"1.24.5"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.3.8";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";import * as Sentry from "@sentry/nextjs";

const packageJson = require("./package.json");

Sentry.init({
  dsn: process.env.NEXT_SENTRY_DSN,
  environment: process.env.APP_MODE,
  release: packageJson.version,
  debug: true,
  attachStacktrace: true,
  enabled: process.env.SENTRY_ENABLE === "true",
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
